/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.project', {
            parent: 'board',
            url: '/board/projects?pageP&sortP&searchP&archiveP&typeP',
            data: {
                authorities: ['ROLE_BOARD','ROLE_MANAGER'],
                pageTitle: 'askApp.project.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/board/project/projects.html',
                    controller: 'ProjectBoardController',
                    controllerAs: 'vm'
                }
            },
            params: {
                pageP: {
                    value: '1',
                    squash: true
                },
                sortP: {
                    value: 'fromDate,desc',
                    squash: true
                },
                archiveP: {
                    value: 'false',
                    squash: true
                },
                typeP: {
                    value: 'all',
                    squash: true
                },
                searchP: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        pageP: PaginationUtil.parsePage($stateParams.pageP),
                        sortP: $stateParams.sortP,
                        predicateP: PaginationUtil.parsePredicate($stateParams.sortP),
                        ascendingP: PaginationUtil.parseAscending($stateParams.sortP),
                        searchP: $stateParams.searchP,
                        archiveP: $stateParams.archiveP,
                        typeP: $stateParams.typeP
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('project');
                    $translatePartialLoader.addPart('enumProjectType');
                    $translatePartialLoader.addPart('enumSksPracticalLocation');
                    $translatePartialLoader.addPart('enumBookingStatusType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('board.project.new', {
            parent: 'board.project',
            url: '/new',
            params: {
              type: null
            },
            data: {
                authorities: ['ROLE_BOARD','ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/project/project-dialog.html',
                    controller: 'ProjectDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            var isBoat = $stateParams.type !== null && $stateParams.type.startsWith('boat');
                            return {
                                name: null,
                                email: null,
                                guestprice: null,
                                prepayment: null,
                                fromDate: null,
                                untilDate: null,
                                places: null,
                                identifier: null,
                                description: null,
                                conditions: null,
                                mailText: null,
                                normalPrice: null,
                                studentPrice: null,
                                type: null,
                                active: false,
                                visible: false,
                                closed: false,
                                queue: true,
                                activityPoints: true,
                                checkRegisterDate: false,
                                guest: false,
                                image: null,
                                imageContentType: null,
                                sepa: false,
                                weight: false,
                                clothingSize: false,
                                shoeSize: false,
                                nationality: isBoat,
                                countryOfBirth: isBoat,
                                birthplace: isBoat,
                                idNumber: isBoat,
                                booked: false,
                                id: null,
                                dependingProject: null,
                                individualField: null,
                                additionalBookable: false,
                                sbfSlotsMax: 2,
                                sksPracticalLocation: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('board.project', null, { reload: 'board.project' });
                }, function() {
                    $state.go('board.project');
                });
            }]
        })
        .state('board.project.delete', {
            parent: 'board.project',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_BOARD']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/project/project-delete-dialog.html',
                    controller: 'ProjectDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Project', function(Project) {
                            return Project.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('board.project', null, { reload: 'board.project' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
